<template>
  <div class="checklist-eng">
    <div class="categorias">Checklist Engenharia / Ferramentaria</div>
    <div class="items">
      <table>
        <thead>
          <tr>
            <th class="item-title">Descrição</th>
            <th class="item-title">Condição</th>
            <th class="item-title">Observação / Ação</th>
            <!-- <th class="item-title">Data</th>
            <th class="item-title">Status</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="l in DataChecklist" :key="l.ID">
            <th class="item-title">{{ l.DESC }}</th>
            <td>
              <div v-if="l.OPCAO == 1">Sim</div>
              <div v-else-if="l.OPCAO == 2">Não</div>
              <div v-else>Não/Ok</div>
            </td>
            <td>{{ l.OBSERVACAO || "Não Aplicável" }}</td>
            <!-- <td>{{ ReformDate(l.DATA) || "N/A" }}</td>
            <td>{{ l.STATUS }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    DataChecklist: "",
  },
  methods: {
    ReformDate(date) {
      const data = new Date(date);
      let dia = ("0" + data.getDate()).slice(-2);
      let mes = ("0" + (data.getMonth() + 1)).slice(-2);
      let ano = data.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>

<style>
</style>
